import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './main.css'
import { initializeTheme } from './services/themeService'

const applyUIMode = () => {
  if (typeof document === 'undefined') return

  // "fast" mode reduces expensive visual effects (blur/animations/shadows) on low-end devices.
  // Override any time via: localStorage.setItem('anna_ui_mode','fancy'|'fast'); location.reload()
  const KEY = 'anna_ui_mode'
  try {
    const stored = localStorage.getItem(KEY)
    const mode = stored === 'fancy' || stored === 'fast' ? stored : 'fast'
    document.documentElement.dataset.ui = mode
  } catch {
    document.documentElement.dataset.ui = 'fast'
  }
}

const cleanupLegacyServiceWorkers = async () => {
  if (!('serviceWorker' in navigator)) return

  // Run only once per browser to avoid unregistering the current PWA worker on every load.
  const FLAG_KEY = 'legacy_sw_cleanup_done_v1'
  if (localStorage.getItem(FLAG_KEY)) return

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    if (registrations.length === 0) return

    await Promise.all(registrations.map((registration) => registration.unregister()))

    if ('caches' in window) {
      const cacheKeys = await caches.keys()
      await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)))
    }

    localStorage.setItem(FLAG_KEY, '1')
    window.location.reload()
  } catch (error) {
    console.warn('Failed to cleanup legacy service workers:', error)
  }
}

applyUIMode()
cleanupLegacyServiceWorkers()

// Initialize festival theme on app start
initializeTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
